import { Injectable } from '@angular/core';
import { ApplicationNotification, INotificationBroker } from './interfaces';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationBrokerService implements INotificationBroker {
  private notifications: Subject<ApplicationNotification> =
    new Subject<ApplicationNotification>();

  emit(notification: ApplicationNotification) {
    this.notifications.next(notification);
  }

  on(): Observable<ApplicationNotification> {
    return this.notifications.asObservable();
  }
}
